<div pmdModal
    modalTrap
    class="modal pmd-modal fade plan-expiry-popup"
    tabindex="-1"
    role="dialog"
    aria-labelledby="planExpiryTitle"
    aria-hidden="true"
    [config]="{ backdrop: 'static' }">
    <div class="modal-dialog modal-dialog-centered">
        <div class="modal-content">
            <div class="modal-header pmd-modal-border plan-expiry-popup-header">
                <h4 class="modal-title"
                    id="planExpiryTitle">Plan expiry reminder</h4>
                <button aria-label="Close"
                    (click)="close()"
                    class="close"
                    type="button">
                    <i class="material-icons-round">close</i>
                </button>
            </div>
            <div class="modal-body">
                <p class="plan-expiry-popup-intro">These Purchase by Petpooja plans are nearing expiry.</p>
                <ul class="plan-expiry-popup-list">
                    <li *ngFor="let notice of notices">
                        <span class="plan-expiry-popup-name">{{ notice.name }}</span>
                        <span class="plan-expiry-popup-days">{{ daysLabel(notice.days) }}</span>
                    </li>
                </ul>
            </div>
            <div class="modal-footer">
                <button aria-label="Close"
                    (click)="close()"
                    type="button"
                    pmd-btn
                    pmdRipple
                    color="secondary">
                    Close
                </button>
            </div>
        </div>
    </div>
</div>
